import { IOptionsWithTypes } from "@eventr/common";
import { Stack } from "@mui/material";
import { cardTranslation } from "i18n/translateHelpers";
import { useUserFilter } from "../hooks/useUserFilter";
import { CardText } from "../subComponents/cardText";
import { Counter } from "../subComponents/counter";
import { UsersList } from "../subComponents/usersLists";
interface TransportDriverProps {
  driver: IOptionsWithTypes[];
}

export const TransportDriver = ({ driver }: TransportDriverProps) => {
  const { filterUsers } = useUserFilter();
  const count = filterUsers(driver).length;
  return (
    <Stack spacing="8px">
      <Stack direction="row" sx={{
        justifyContent: "space-between"
      }}>
        <CardText variant="bodyBold">{cardTranslation("Driver")}</CardText>
        <Counter count={count} />
      </Stack>
      <UsersList userList={driver} />
    </Stack>
  );
};
